<script lang="ts">
    import { onDestroy, onMount } from "svelte";

    import type Connection from "../clienthandler";
    import DefaultContainer from "../DefaultContainer.svelte";

    import { state } from "../state";

    let resolve;
    let startGamePromise = new Promise((r) => (resolve = r));

    $state.connection.registerMessageListener("quickplay_lobby", (message) => {
        switch (message.type) {
            case "LobbyJoined":
                $state.mySide = message.yourSide;
                break;
            case "GameStarted":
                console.log("quick play received game started event");
                resolve();
                setTimeout(() => ($state.currentPage = "game"), 500);
                break;
        }
    });
    onDestroy(() =>
        $state.connection.unregisterMessageListener("quickplay_lobby")
    );
</script>

<DefaultContainer>
    <h1>QuickPlay</h1>
    {#await startGamePromise}
        <p>Waiting for other player...</p>
    {:then _}
        <p>Game started!</p>
    {/await}
</DefaultContainer>
